<ng-template #spinner>
   <mat-spinner id="mapSpinnerContainers" diameter="30"></mat-spinner>
</ng-template>

<ng-container [formGroup]="shipment.shipmentForm">
   <ng-container *ngIf="containers">
      <mat-expansion-panel #containersExpansionPanel id="containers" class="bordered" [class.invalid]="(shipment.highlightInvalid$ | async) && (containers.invalid || containerFormGroup.invalid )">
         <mat-expansion-panel-header>
            <mat-panel-title id="itemCalculatorPanelTitle">Item Calculator</mat-panel-title>
         </mat-expansion-panel-header>

         <div class="toggle-buttons">
            <ng-container *ngIf="shipment.shipmentForm.get('shippingType')">
               <mat-form-field class="shipingtype common-w25">
                  <mat-select id="shippingTypeSelect" formControlName="shippingType">
                     <mat-select-trigger color="primary">
                        <mat-icon id="shippingTypeIcon" class="shippingtype-icon" [svgIcon]="shippingType.value === 'FCL' ? 'FCL' : 'LCL'"></mat-icon> {{shippingType.value}}
                     </mat-select-trigger>
                     <mat-option id="shippingTypeOption" *ngFor="let type of shippingTypes" [value]="type">
                        <mat-icon id="shippingTypeIcon" [svgIcon]="type === 'FCL' ? 'FCL' : 'LCL'"></mat-icon> {{type}}
                     </mat-option>
                  </mat-select>
               </mat-form-field>
            </ng-container>

            <ng-container *ngIf="itemsType.value === 'FCL'">
               <mat-slide-toggle id="itemizedToggle" formControlName="itemized">Itemized</mat-slide-toggle>
            </ng-container>
         </div>

         <ng-container *ngIf="itemsType.value === 'FCL' else lclTemplate">
            <mat-divider></mat-divider>
            <!-- Itemized -->
            <ng-container *ngIf="itemized else nonItemized">
               <ng-container *ngFor="let container of containers.controls; index as index;">
                  <ng-container [formGroup]="container">
                     <div>
                        CONTAINER {{index + 1}}

                        <button id="containerMenuButton" mat-icon-button [matMenuTriggerFor]="containerMenu" class="common-ml1em">
                           <mat-icon id="containerMenuIcon">more_vert</mat-icon>
                        </button>
                        <mat-menu #containerMenu>
                           <button id="duplicateContainerButton" mat-menu-item (click)="addContainer( container.value )">
                              <mat-icon id="duplicateContainerIcon">library_add</mat-icon> DUPLICATE CONTAINER
                           </button>
                           <button id="removeContainerButton" mat-menu-item *ngIf="index" (click)="removeContainer( index )">
                              <mat-icon id="removeContainerIcon">clear</mat-icon> REMOVE CONTAINER
                           </button>
                        </mat-menu>
                     </div>

                     <mat-form-field>
                        <mat-label>Container #</mat-label>
                        <input id="containerNumberInput" matInput formControlName="number" />
                     </mat-form-field>

                     <mat-form-field *ngIf="enums.containerTypes() | async as types; else spinner" class="common-ml1em">
                        <mat-label>Container Type</mat-label>
                        <mat-select id="containerTypeSelect" formControlName="type" required>
                           <mat-option id="containerTypeOption" *ngFor="let type of types" [value]="type">{{type}}</mat-option>
                        </mat-select>
                        <mat-error id="containerTypeError">Required</mat-error>
                     </mat-form-field>

                     <calculator-items [items]="containers.at( index ).get( 'items' )"></calculator-items>
                  </ng-container>

                  <mat-divider></mat-divider>
               </ng-container>

               <button id="addContainerButton" mat-stroked-button (click)="addContainer()">
                  <mat-icon id="addContainerIcon">add</mat-icon> ADD CONTAINER
               </button>
            </ng-container>

            <!-- Non Itemized -->
            <ng-template #nonItemized>
               <ng-container [formGroup]="containerFormGroup">
                  <ng-container formArrayName="containerArray">
                     <ng-container *ngFor="let cont of containerArray.controls; index as index;">
                        <ng-container [formGroupName]="index">
                           <div>
                              CONTAINER GROUP {{index + 1}}

                              <button id="containerMenuButton" mat-icon-button *ngIf="index" [matMenuTriggerFor]="containerGroupMenu" class="common-ml1em">
                                 <mat-icon id="containerMenuIcon">more_vert</mat-icon>
                              </button>
                              <mat-menu #containerGroupMenu>
                                 <button id="removeContainerGroupButton" mat-menu-item (click)="removeContainerArrayGroup( index )">
                                    <mat-icon id="removeContainerGroupIcon">clear</mat-icon> REMOVE CONTAINER GROUP
                                 </button>
                              </mat-menu>

                           </div>

                           <mat-form-field>
                              <mat-label>Quantity</mat-label>
                              <input id="quantityInput" matInput type="number" min="0" formControlName="quantity" />
                           </mat-form-field>

                           <mat-form-field *ngIf="enums.containerTypes() | async as types; else spinner" class="common-ml1em">
                              <mat-label>Container Type</mat-label>
                              <mat-select id="containerTypeSelect" formControlName="type" required>
                                 <mat-option id="containerTypeOption" *ngFor="let type of types" [value]="type">{{type}}</mat-option>
                              </mat-select>
                              <mat-error id="containerTypeError">Required</mat-error>
                           </mat-form-field>

                           <mat-expansion-panel #containersPanel *ngIf="cont.get( 'containers' ).value">
                              <mat-expansion-panel-header>
                                 <ng-container id="containerNumbers" *ngIf="containersPanel.expanded">CONTAINER NUMBERS</ng-container>
                                 <ng-container *ngIf="!containersPanel.expanded">
                                    <mat-icon>add</mat-icon>
                                    <span id="enterContainerNumbers" class="containers-text">ENTER CONTAINER NUMBERS</span>
                                 </ng-container>
                              </mat-expansion-panel-header>

                              <ng-container *ngFor="let container of cont.get( 'containers' ).controls; index as index;">
                                 <div class="containers-panel" [formGroup]="container">
                                    <mat-form-field>
                                       <mat-label>Container {{index + 1}}</mat-label>
                                       <input id="enterContainer" matInput formControlName="number" />
                                    </mat-form-field>
                                 </div>
                              </ng-container>
                           </mat-expansion-panel>
                        </ng-container>

                        <mat-divider></mat-divider>
                     </ng-container>
                  </ng-container>
               </ng-container>

               <button id="addContainerGroup" mat-stroked-button (click)="addContainerArrayGroup()">
                  <mat-icon id="addContainerGroupIcon">add</mat-icon> ADD CONTAINER GROUP
               </button>
            </ng-template>

         </ng-container>

         <!-- Default -->
         <ng-template #lclTemplate>
            <calculator-items [items]="calculator"></calculator-items>
         </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="containersExpansionPanel.expanded" class="bordered" *ngIf="itemsType.value === 'LCL'">
         <mat-expansion-panel-header>
            <mat-panel-title id="itemTotalsPanelTitle">Item Totals</mat-panel-title>
         </mat-expansion-panel-header>

         <div class="item-totals" *ngIf="calculator as items">
            <div>
               <div id="totalPiecesLabel" class="overline">Total Pieces</div>
               <div id="totalPieces">{{items.value | total: 'pieces' | number}}</div>
            </div>
            <div *ngIf="items.value | totalweight">
               <div id="totalWeightLabel" class="overline">Total Weight</div>
               <div id="totalWeight">{{items.value | totaldualweight }}</div>
            </div>
            <div *ngIf="items.value | totalvolume">
               <div id="totalVolumeLabel" class="overline">Volume Weight</div>
               <div id="totalVolume">{{items.value | totaldualvolume }}
               </div>
            </div>
         </div>
      </mat-expansion-panel>
   </ng-container>
</ng-container>
